import { useQuery } from 'react-query';

import { SmartRecruitersIntegration } from 'src/generated/mloop-graphql';

import { ApiVerb, apiPost } from 'src/utils/api';

import {
  AshbyIntegration,
  BrighthireStoreIntegration,
  CodeSignalIntegration,
  CoderPadIntegration,
  CodilityIntegration,
  GemIntegration,
  GoogleIntegration,
  GreenhouseOAuthIntegration,
  HackerRankIntegration,
  KomboIntegration,
  LeverIntegration,
  MicrosoftGccHighIntegration,
  MicrosoftIntegration,
  MicrosoftServiceUserIntegration,
  MultiDomainIntegration,
  QUERY_KEY,
  SlackOrgIntegration,
  WorkdayIntegration,
  ZoomCustomIntegration,
  ZoomIntegration,
} from './types';

export interface ListIntegrationResponse {
  workday?: WorkdayIntegration;
  gem?: GemIntegration;
  org_id?: string;
  ashby?: AshbyIntegration;
  coderpad?: CoderPadIntegration;
  codesignal?: CodeSignalIntegration;
  google?: GoogleIntegration;
  microsoft_gcc_high?: MicrosoftGccHighIntegration;
  microsoft_custom?: MicrosoftIntegration;
  microsoft?: MicrosoftIntegration;
  greenhouse_oauth?: GreenhouseOAuthIntegration;
  lever?: LeverIntegration;
  zoom?: ZoomIntegration;
  zoom_custom?: ZoomCustomIntegration;
  slack?: SlackOrgIntegration;
  hackerrank?: HackerRankIntegration;
  codility?: CodilityIntegration;
  smart_recruiters?: SmartRecruitersIntegration;
  kombo?: KomboIntegration;
  brighthire?: BrighthireStoreIntegration;
  microsoft_service_user?: MicrosoftServiceUserIntegration;
  multi_domain?: MultiDomainIntegration;
}

async function listIntegration(): Promise<ListIntegrationResponse> {
  const response = await apiPost(ApiVerb.LIST_INTEGRATION, {});
  return response.data;
}

/**
 * @deprecated - Use thisOrg.integrations GQL instead
 */
export default function useIntegrations() {
  return useQuery(QUERY_KEY, () => listIntegration());
}
